import { logger } from '@/services/LoggingService';

/**
 * Ensures a value is a valid Vezgo account ID string
 * This function provides both runtime validation and type safety
 * @param value Any input value that should be a Vezgo account ID
 * @returns A guaranteed string Vezgo account ID
 * @throws Error if the value cannot be safely converted to a string
 */
export function ensureVezgoAccountId(value: unknown): string {
  if (value === null || value === undefined) {
    const error = new Error('VezgoAccountId cannot be null or undefined');
    logger.error('ensureVezgoAccountId', 'Invalid account ID', { error });
    throw error;
  }
  
  // Convert to string and validate
  const stringValue = String(value);
  if (!stringValue) {
    const error = new Error('VezgoAccountId cannot be empty');
    logger.error('ensureVezgoAccountId', 'Empty account ID', { error });
    throw error;
  }
  
  return stringValue;
}

/**
 * Type guard to check if a value is a valid Vezgo account ID
 */
export function isValidVezgoAccountId(value: unknown): value is string {
  if (value === null || value === undefined) return false;
  const stringValue = String(value);
  return stringValue.length > 0;
}
